module.exports = __webpack_public_path__ + "static/img/3-leak-resend-selected.c19b8af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-leak-resend-selected.png
// module id = 1330
// module chunks = 0